import PrevStudies from './PrevStudies';

export default PrevStudies;